import CatalogService from "@/services/catalog.service";
import CustomerSevice from "@/services/customer.service";
import SettingsService from "@/services/settings.service";

const catalogservice = new CatalogService();
const customerservice = new CustomerSevice();
const settingsService = new SettingsService();

export default {
    getters: {
        getApiData: () => {
            let apiData = localStorage.getItem("apiData");
            let localestoreApiData = apiData ? JSON.parse(apiData) : {};
            return localestoreApiData !== null ? localestoreApiData : {};
        },
        getCachedApiData: () => {
            let apiData = localStorage.getItem("apiData");
            let localestoreApiData = apiData ? JSON.parse(apiData) : {};
            return localestoreApiData !== null ? localestoreApiData : {};
        },
    },
    actions: {
        async fetchDataFromApi() {
            return new Promise(async(resolve) => {
                let categories, customers, items, settings;
                try {
                    const catalog = await catalogservice.get();
                    categories = catalog.data.categories;
                    items = catalog.data.items.map((item) => {
                        return {...item, name: item.name.toLowerCase(), tax: Number(item.tax) || 0, discount: 0 };
                    });
                } catch (error) { console.error("[fetchDataFromApi] catalog:", error); }

                try {
                    const response = await customerservice.get();
                    customers = response.data;
                } catch (error) { console.error("[fetchDataFromApi] customers:", error); }

                try {
                    const response = await settingsService.get();
                    settings = response.data;
                } catch (error) { console.error("[fetchDataFromApi] settings:", error); }
                let apiData = {
                    categories,
                    items: items,
                    customers,
                    settings,
                };
                localStorage.setItem("apiData", JSON.stringify(apiData));
                resolve(apiData);
            });
        },

        updateCustomersApiData({ getters }, payload) {
            let storedAPiData = getters.getCachedApiData;
            storedAPiData = {...storedAPiData, customers: payload };
            localStorage.setItem("apiData", JSON.stringify(storedAPiData));
        },

        async updateItemsApiData({ getters }) {
            let items;
            let categories;
            try {
                const catalog = await catalogservice.get();
                categories = catalog.data.categories;
                items = catalog.data.items.map((item) => {
                    return {...item, name: item.name.toLowerCase(), tax: Number(item.tax) || 0 };
                });
            } catch (error) {}
            let storedAPiData = {...getters.getCachedApiData, items, categories };
            localStorage.setItem("apiData", JSON.stringify(storedAPiData));
        },

        async getApiData({ getters, dispatch }) {
            const cached = getters.getCachedApiData;
            console.log("[getApiData] cached keys:", Object.keys(cached).length, "items:", cached.items?.length);
            if (Object.keys(cached).length === 0 || !cached.items?.length) {
                console.log("[getApiData] cache vide ou items manquants → fetchDataFromApi");
                return dispatch("fetchDataFromApi");
            }
            try {
                const response = await settingsService.get();
                const remoteUpdated = response.data?.store?.updated;
                const cachedUpdated = cached.settings?.store?.updated;
                console.log("[getApiData] remoteUpdated:", remoteUpdated, "cachedUpdated:", cachedUpdated);
                if (remoteUpdated && remoteUpdated !== cachedUpdated) {
                    console.log("[getApiData] settings changés → fetchDataFromApi");
                    return dispatch("fetchDataFromApi");
                }
            } catch (error) {
                console.log("[getApiData] erreur settings:", error);
            }
            return cached;
        },
    },
};